import React, { useState, useEffect } from "react";
import clinicService from "../../../../../services/clinic.service";
import { useParams } from "react-router-dom";
import NewReputation from "./NewReputation";
import Links from "./Links";
import CommentsTable from "./CommentsTable";
import FeedbackTable from "./FeedbackTable";
import Loading from "../../../../common/Loading";

function ReputationTab() {
    const [isEditing, setIsEditing] = useState(false);
    const { clinicId } = useParams();
    const [hasReputationService, setHasReputationService] = useState(false);
    const [shortCode, setShortCode] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        checkReputationService();
    }, [clinicId]);

    const checkReputationService = () => {
        setLoading(true);
        clinicService.getReputationClinic(clinicId)
            .then(res => {
                setShortCode(res.data.shortCode);
                setHasReputationService(true);
            })
            .catch(error => {
                setHasReputationService(false);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    if (loading) {
        return (
            <Loading />
        );
    }

    return (
        <div className="container-fluid px-0">
            <div className="card shadow-none card-padding">
                <div className="card-title bg-transparent border-0 pt-4 pb-0">
                    <i className="bi bi-star-fill me-2"></i>Reputation Enhancement
                </div>
                <div className="card-body">
                    {!hasReputationService ? (
                        <NewReputation clinicid={clinicId} checkReputationService={checkReputationService} />
                    ) : (
                        <>
                            <div className="row mt-2 mb-4">
                                <div className="col-12">
                                    <div className="border-start border-4 border-primary ps-3">
                                        <h6 className="text-primary mb-1">Your Short Code</h6>
                                        <p className="text-muted small mb-2">This code is used in your reputation URLs. e.g. https://eyeconx.com/{shortCode}</p>
                                        <div className="d-inline-block bg-light px-3 py-2 rounded">
                                            <code className="fs-5 fw-bold text-dark">{shortCode}</code>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="mt-5">
                                <div className="mb-3 border-bottom pb-2"><i className="bi bi-gear me-2"></i> Reputation Management</div>
                                <div className="mb-5">
                                    <Links clinicid={clinicId} />
                                </div>

                                <div className="mb-5 card card-border shadow-none">
                                    <CommentsTable clinicid={clinicId} />
                                </div>

                                <div className="mb-5 card card-border shadow-none">
                                    <FeedbackTable clinicid={clinicId} />
                                </div>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ReputationTab;